export default __webpack_public_path__ + "static/media/mobile.c68bb679.png";